
angular.module('zc.master')
  .component('zcCampaignBadges', {
    templateUrl: '/templates/master/components/campaign_badges.html',
    bindings: {
      campaigns: '<',
    },
    controller: zcCampaignBadges,
    controllerAs: 'vm',
  });

zcCampaignBadges.$inject = ['$scope', 'campaignStatuses'];
function zcCampaignBadges($scope, campaignStatuses) {
  const vm = this;
  vm.campaignStatuses = campaignStatuses;

  vm.$onInit = () => vm.updateData();
  vm.updateData = () => {
    vm.secretAbCampaignCount = _.filter(vm.campaigns, { is_secret_ab: true }).length;
    vm.unfinishedCampaigns = _.filter(vm.campaigns, campaign => !['finished', 'terminated'].includes(campaign.current_status));
    vm.undeliveredCampaignCount = _.filter(vm.unfinishedCampaigns, campaign => !campaign.is_fired).length;
    vm.campaignCountByStatus = _.countBy(_.sortBy(vm.campaigns, 'current_status'), campaign => campaign.current_status);
  };

  $scope.$watch('vm.campaigns', vm.updateData);
}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/components/campaign_badges.js